import React from 'react';
import PropTypes from 'prop-types';
import './file-preview.scss';

const PdfFilePreview = ({ fileName, url }) => (
  <iframe
    src={url}
    frameBorder="0"
    styleName="pdf-previewer"
    title={fileName ? `PDF preview: ${fileName}` : 'PDF preview'}
  />
);

PdfFilePreview.propTypes = {
  fileName: PropTypes.string,
  url: PropTypes.string
};

export default PdfFilePreview;
